import React from "react";
import { HashLink } from "react-router-hash-link";

const MessageBoardTable = ({ boards }) => {
  return (
    <div>
      <table cellpadding="0" cellspacing="0" border="0">
        <colgroup>
          <col class="col-1" />
          <col class="col-7" />
          <col class="col-1" />
          <col class="col-2" />
          <col class="col-1" />
        </colgroup>
        <thead
          style={{
            borderBottom: "1px solid gray",
            width: "100%",
            height: "20px",
          }}
        >
          <tr>
            <th class="align-center">번호</th>
            <th class="align-center">제목</th>
            <th class="align-center">작성자</th>
            <th class="align-center">작성일</th>
            <th class="align-center">조회수</th>
          </tr>
        </thead>
        <tbody>
          {boards.map((board, idx) => {
            return (
              <>
                <tr>
                  <td class="align-center">{boards.length - idx}</td>
                  <td class="align-left">
                    <HashLink to={"/message-board/" + board.id}>
                      <div dangerouslySetInnerHTML={{ __html: board.title }} />
                    </HashLink>
                  </td>

                  <td class="align-center">헤즐릿</td>
                  <td class="align-center">
                    {board?.created &&
                      board?.created?.toDate().toLocaleDateString("fr-CA", {
                        year: "numeric",
                        month: "2-digit",
                        day: "2-digit",
                      })}
                  </td>
                  <td class="align-center">{board.viewed}</td>
                </tr>
              </>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MessageBoardTable;
